import { decode } from 'js-base64';
import { type JsonValue } from 'type-fest';

// JSON.parse returns an any type
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const decodeId = <T extends JsonValue>(id: string): T => JSON.parse(decode(decodeURIComponent(id))) as T;
